export default "https://cdn-static.gokick.com/assets/316c05c5b819a67ca00dcd3ca58b5d19adb19ecb/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";